import { REGISTRATION_DESKTOP_MEDIA_QUERY } from './layout.constants';

export const canDetectAuthViewport = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return typeof window.matchMedia === 'function';
};

export const isAuthDesktopViewport = (): boolean => {
  if (!canDetectAuthViewport()) {
    return false;
  }

  return window.matchMedia(REGISTRATION_DESKTOP_MEDIA_QUERY).matches;
};
